import { useTranslation } from 'react-i18next';

function ErisFooter() {
  const { t } = useTranslation();

  return (
    <div className="border-t border-blue-900 bg-white py-3">
      <p className="text-left text-sm text-gray-500">
        {typeof t === 'function' ? t('eris.common.footer') : ''}
      </p>
    </div>
  );
}

export default ErisFooter;
